import type { InjectionKey } from 'vue'

export const LINK_SELECT_MENU_MAX_HEIGHT = 320

export type LinkSelectMenuProps = {
  maxHeight?: number
  zIndex?: number
}

export const linkSelectMenuPropsKey: InjectionKey<LinkSelectMenuProps> = Symbol('linkSelectMenuProps')

/** Merges default max-height with optional parent overrides (e.g. modal z-index). */
export function buildLinkSelectMenuProps(
  overrides?: LinkSelectMenuProps | null,
): LinkSelectMenuProps {
  return {
    maxHeight: LINK_SELECT_MENU_MAX_HEIGHT,
    ...overrides,
  }
}
